import React from "react"
import FaceBook from "../Icons/FaceBook"
import Twitter from "../Icons/Twitter"
import Linkedin from "../Icons/Linkedin"
import Youtube from "../Icons/Youtube"
import { SocialList,  SocialIcon, } from "../SectionTags"

const Social = () => {
    return (
        <SocialList className="social-list">
            <SocialIcon className="social-icon">
            <a
                href="https://www.facebook.com/aesintl1992/"
                target="_blank"
                rel="noreferrer"
                aria-label="facebook"
            >
                <FaceBook />
            </a>
            </SocialIcon>
            <SocialIcon className="social-icon">
            <a
                href="https://twitter.com/AES_INC1992"
                target="_blank"
                rel="noreferrer"
                aria-label="twitter"
            >
                <Twitter />
            </a>
            </SocialIcon>
            <SocialIcon className="social-icon">
            <a
                href="https://www.linkedin.com/company/aes-inc-repairs"
                target="_blank"
                rel="noreferrer"
                aria-label="linkedin"
            >
                <Linkedin />
            </a>
            </SocialIcon>
            <SocialIcon className="social-icon">
            <a
                href="https://www.youtube.com/channel/UCuZ9fYNg7lHPUM2An-ZHEzg"
                target="_blank"
                rel="noreferrer"
                aria-label="youtube"
            >
                <Youtube />
            </a>
            </SocialIcon>
        </SocialList>
    )
}

export default Social
